import { useCallback, useRef, useState } from 'react';
import { notifications } from '@mantine/notifications';
import type { CibusStatusAction, OrderView } from 'shared-models/browser';
import { posCibusService } from '../../../../../services/pos-cibus/pos-cibus.service';

type Params = {
  tenantId: string;
  employeeSession: string | null;
  orderId: number;
};

// One in-flight action per order; the local state patches arrive through the POS SSE deltas.
export function useCibusOrderActions({ tenantId, employeeSession, orderId }: Params) {
  const [inFlight, setInFlight] = useState<CibusStatusAction | null>(null);
  const inFlightRef = useRef(false);

  const apply = useCallback(async (action: CibusStatusAction, reason?: string): Promise<OrderView | null> => {
    if (!employeeSession || inFlightRef.current) {
      return null;
    }
    inFlightRef.current = true;
    setInFlight(action);
    try {
      return await posCibusService.applyStatus(tenantId, employeeSession, orderId, reason ? { action, reason } : { action });
    } catch (error: unknown) {
      notifications.show({
        color: 'red',
        title: 'סיבוס',
        message: error instanceof Error ? error.message : 'עדכון ההזמנה בסיבוס נכשל',
        autoClose: 4000,
      });
      return null;
    } finally {
      inFlightRef.current = false;
      setInFlight(null);
    }
  }, [employeeSession, orderId, tenantId]);

  return { inFlight, apply };
}
